import { normalizePath, useSetFlowTo } from 'Simple/Flow'
import { useDataChange } from 'Simple/Data.js'
import { notifySuccess, useNotifications } from 'Logic/Notifications.js'

export function useOnLauncherResolved(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let changeComponent = useDataChange({
    viewPath: props.viewPath,
    context: 'component',
  })
  let [, notify] = useNotifications()

  return async function onLauncherResolved({ launcher, response }) {
    switch (launcher.type) {
      case 'URL_HTTP':
      case 'URL_STATIC': {
        switch (launcher.displayFormat) {
          case 'MODAL_FULLSCREEN': {
            changeComponent({
              name: launcher.name,
              url: response.url,
            })
            setFlowTo(
              normalizePath(
                props.viewPath,
                '../../../LauncherModalFullscreen/Content'
              )
            )
            break
          }

          case 'NEW_WINDOW':
          default: {
            window.open(response.url)
            changeComponent(null)
            break
          }
        }
        break
      }

      case 'ACTION_COMPONENT': {
        changeComponent(response.component)
        setFlowTo(normalizePath(props.viewPath, '../../../AppComponent'))
        break
      }

      default: {
        break
      }
    }

    if (response.message) {
      notify(notifySuccess(response.message))
    }
  }
}
